import consumer from "./consumer"

consumer.subscriptions.create("ChatChannel", {
  connected() { },

  disconnected() { },

  received(data) {
    console.log(data)
  },
})